import {
	reOrgConversionMeasurementUnitConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	error      : null,
	isSending  : false,
	paged      : {},
	pagedAudit : {},
	changed    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case (reOrgConversionMeasurementUnitConstants.Create.REQUEST):
		case (reOrgConversionMeasurementUnitConstants.Restore.REQUEST):
		case (reOrgConversionMeasurementUnitConstants.Update.REQUEST):
		case (reOrgConversionMeasurementUnitConstants.Delete.REQUEST):
		case reOrgConversionMeasurementUnitConstants.DeleteSelected.REQUEST:
		case reOrgConversionMeasurementUnitConstants.DeleteByFilter.REQUEST:
		case (reOrgConversionMeasurementUnitConstants.GetPaged.REQUEST):
		case (reOrgConversionMeasurementUnitConstants.GetPagedAudit.REQUEST):
		case (reOrgConversionMeasurementUnitConstants.GetExampleFile.REQUEST):
		case (reOrgConversionMeasurementUnitConstants.Upload.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reOrgConversionMeasurementUnitConstants.Create.FAILURE):
		case (reOrgConversionMeasurementUnitConstants.Restore.FAILURE):
		case (reOrgConversionMeasurementUnitConstants.Update.FAILURE):
		case (reOrgConversionMeasurementUnitConstants.Delete.FAILURE):
		case reOrgConversionMeasurementUnitConstants.DeleteSelected.FAILURE:
		case reOrgConversionMeasurementUnitConstants.DeleteByFilter.FAILURE:
		case (reOrgConversionMeasurementUnitConstants.GetPaged.FAILURE):
		case (reOrgConversionMeasurementUnitConstants.GetPagedAudit.FAILURE):
		case (reOrgConversionMeasurementUnitConstants.GetExampleFile.FAILURE):
		case (reOrgConversionMeasurementUnitConstants.Upload.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (reOrgConversionMeasurementUnitConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reOrgConversionMeasurementUnitConstants.GetPagedAudit.SUCCESS):
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result
			}
		case (reOrgConversionMeasurementUnitConstants.Create.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case (reOrgConversionMeasurementUnitConstants.Restore.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reOrgConversionMeasurementUnitConstants.Delete.SUCCESS:
		case reOrgConversionMeasurementUnitConstants.DeleteSelected.SUCCESS:
		case reOrgConversionMeasurementUnitConstants.DeleteByFilter.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case (reOrgConversionMeasurementUnitConstants.Update.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (reOrgConversionMeasurementUnitConstants.GetExampleFile.SUCCESS):
			return {
				...state,
				isSending: false
			}
		case (reOrgConversionMeasurementUnitConstants.Upload.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}
		case (reOrgConversionMeasurementUnitConstants.CLEAR):
			return {
				...state,
				error      : null,
				isSending  : false,
				paged      : {},
				pagedAudit : {},
				changed    : null
			}
		default:
			return state
	}
}